import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getFormValues, reduxForm } from 'redux-form';
import { compose } from 'redux';
import _ from 'lodash';
import moment from 'moment';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { USER_REPORTS } from 'src/constants/EndpointUrls';
import { USER_WITHHOLDING_REPORTS_FORM } from 'src/constants/FormNames';
import { fetchUserWithholdingReport, REDUCER_NAME } from 'src/reducers/users/withholdingReport';
import SearchDetector from 'src/components/SearchDetector';
import { isLoading } from 'src/reducers/common/itemReducer';
import LoadingView from 'src/components/LoadingView';
import { getSelectOptions } from 'src/reducers/selectOptions';

import styles from './ShowWithholdingReport.scss';
import WithholdingReportTable from './components/WithholdingReportTable';
import YearSelector from './components/YearSelector';

const ShowWithholdingReport = ({ selectedYear, fetchWithholdingReport, isFetchingReport }) => {
  const { t } = useTranslation();

  return (
    <div>
      <SearchDetector
        year={selectedYear}
        willReceivePropsDetectingJudger={(prevProps, nextProps) => prevProps.year !== nextProps.year}
        onDetect={() => fetchWithholdingReport(selectedYear)}
      />
      <div className="l-wrap-xl l-contents-wrap">
        <BreadCrumb>
          <BreadCrumb.Item label={t('features.Users.components.ShowWithholdingReport.create_document')} path={USER_REPORTS} />
          <BreadCrumb.Item label={t('features.Users.components.ShowWithholdingReport.withholding_tax_certificate')} />
        </BreadCrumb>
        <div className="l-title-wrap">
          <h1 className="m-title-main">{t('features.Users.components.ShowWithholdingReport.withholding_tax_certificate')}</h1>
          <ul className={styles.notes}>
            <li>{t('features.Users.components.ShowWithholdingReport.pdf_export_is_possible_if_there_is_confirmed_data_in_the_selected_year')}</li>
          </ul>

          <YearSelector />
          <div className="u-mt20">
            <LoadingView isLoading={isFetchingReport}>
              <WithholdingReportTable />
            </LoadingView>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  initialValues: {
    year: _.get(getSelectOptions(state, 'paymentYears'), '[0].value', moment().year()),
    issuedDate: null
  },
  selectedYear: _.get(getFormValues(USER_WITHHOLDING_REPORTS_FORM)(state), 'year', null),
  isFetchingReport: isLoading(REDUCER_NAME, state)
});

const mapDispatchToProps = {
  fetchWithholdingReport: fetchUserWithholdingReport
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: USER_WITHHOLDING_REPORTS_FORM,
    enableReinitialize: true
  })
)(ShowWithholdingReport);
